/**
 * Storage Utility
 * Handles localStorage operations for the application
 */

// =======================
// Token Management
// =======================

export const setToken = (token) => {
  if (token) {
    localStorage.setItem("token", token);
  }
};

export const getToken = () => {
  return localStorage.getItem("token");
};

export const removeToken = () => {
  localStorage.removeItem("token");
};

// =======================
// User Management
// =======================

export const setUser = (userData) => {
  if (userData) {
    localStorage.setItem("user", JSON.stringify(userData));
  }
};

export const getUser = () => {
  const user = localStorage.getItem("user");
  return user ? JSON.parse(user) : null;
};

export const removeUser = () => {
  localStorage.removeItem("user");
};

// =======================
// Clear All Storage
// =======================

export const clearStorage = () => {
  localStorage.removeItem("token");
  localStorage.removeItem("user");
};

// =======================
// Auth Check
// =======================

export const isAuthenticated = () => {
  return !!getToken();
};
